export default __webpack_public_path__ + "static/media/wind-turbine.3301bdba.svg";